// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"24":"leaguevideos","37":"draftroom","141":"history","185":"season2021","466":"constitution","552":"rules","770":"leaguelosers"}[chunkId] + "." + {"24":"df0083fb","37":"9ddeb54d","141":"511255ba","185":"28c6ea32","466":"1382c358","552":"dadd488c","770":"1a603a43"}[chunkId] + ".js";
};